import React, { memo } from 'react';
import { TopPicks4U } from '@browsing/top-picks-4U';
import { ContinueShoppingCarousel } from '@client/components/continue-shopping';
import { EACarousel } from '@client/components/mylounge/plus/ea-carousel';
import { useGridLayoutContext } from '../context/GridLayoutContext';
import { SemanticArticleCarousel } from '../../../semantic-article-carousel';
import { CampaignBlock, Slot, DeclarativeGrid } from '../components';

const FourColumnLayoutComponent: React.FC = () => {
    const {
        topPicks4UGenderData,
        isContinueShopping,
        carousels,
        isSemanticArticleCarousel,
        isEACarousel,
    } = useGridLayoutContext();
    const { gender, profileFashionPreference, selectedFashionPreference } = topPicks4UGenderData;

    return (
        <DeclarativeGrid>
            {/* Header section with showstoppers */}
            {isEACarousel && <EACarousel />}
            <CampaignBlock
                slots={[Slot.LARGE_SQUARE, Slot.SQUARE, Slot.SQUARE, Slot.HORIZONTAL_RECTANGLE]}
            />
            {isSemanticArticleCarousel && <SemanticArticleCarousel />}
            <TopPicks4U
                gender={gender}
                profileFashionPreference={profileFashionPreference}
                selectedFashionPreference={selectedFashionPreference}
            />
            <CampaignBlock
                slots={[
                    Slot.SQUARE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.HORIZONTAL_RECTANGLE,
                ]}
            />
            {carousels.newDeals || carousels.leavingSoon}
            <CampaignBlock
                slots={[
                    Slot.SQUARE,
                    Slot.LARGE_SQUARE,
                    Slot.SQUARE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.HORIZONTAL_RECTANGLE,
                ]}
            />
            {isContinueShopping && <ContinueShoppingCarousel />}
            <CampaignBlock
                slots={[
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.LARGE_SQUARE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                ]}
            />
            <CampaignBlock
                slots={[
                    Slot.VERTICAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.HORIZONTAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.LARGE_SQUARE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                ]}
            />
            <CampaignBlock
                slots={[
                    Slot.SQUARE,
                    Slot.HORIZONTAL_RECTANGLE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                ]}
            />
            <CampaignBlock slots={[Slot.HORIZONTAL_RECTANGLE, Slot.SQUARE, Slot.SQUARE]} />
            <CampaignBlock
                slots={[Slot.LARGE_SQUARE, Slot.SQUARE, Slot.VERTICAL_RECTANGLE, Slot.SQUARE]}
            />
        </DeclarativeGrid>
    );
};

export const FourColumnLayout = memo(FourColumnLayoutComponent);
